import React, { useContext } from 'react';
import styled from '@emotion/styled';

import PlaceholderText from '../components/core/PlaceholderText';
import { StoreContext } from '../StoreContext';
import { percentify, thousandify } from '../utils/NumFmtUtils';

export const ViewingCount = () => {
  const { filterCount, filterIsLoading, totalDocCount } =
    useContext(StoreContext);

  return (
    <Root data-test-id="viewing-count">
      {filterIsLoading ? (
        <>
          <PlaceholderText style={{ width: '3rem' }} /> (
          <PlaceholderText style={{ width: '2rem' }} />)
        </>
      ) : (
        <>
          {thousandify(filterCount)} ({percentify(filterCount, totalDocCount)})
        </>
      )}{' '}
      records
    </Root>
  );
};

const Root = styled.span`
  flex-shrink: 0;
  font-family: ${({ theme }) => theme.font.sans};
  font-size: 14px;
  white-space: nowrap;
  color: ${({ theme }) => theme.color.fg.muted};
`;
